import Service from "../service";
// import AuthService from "../AuthServ

const Hospital = {
    getHospital() {
        return Service.get('/hospital')
    },
};


export default Hospital;
